import { inject, Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'timestampToDate',
})
export class TimestampToDatePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(timestamp: number | undefined, format: 'date' | 'string'): Date | string | undefined {
    const modifier = 10 ** (13 - String(timestamp).length); // INFO: Длина Timestamp в миллисекундах = 13
    const timestampMilliseconds = timestamp ? timestamp * modifier : undefined;
    const locale = this.translateService.currentLang;

    if (format === 'date') return timestampMilliseconds ? new Date(timestampMilliseconds) : undefined;
    if (format === 'string') {
      let dateToString = '';

      if (timestampMilliseconds) {
        const date = formatDate(new Date(timestampMilliseconds), 'dd.MM.yyyy', locale);
        const today = formatDate(new Date(), 'dd.MM.yyyy', locale);
        const weekAgo = Date.now() - 604800000; // INFO: Неделя

        if (date === today) {
          dateToString = formatDate(new Date(timestampMilliseconds), 'HH:mm', locale);
        } else if (timestampMilliseconds > weekAgo) {
          dateToString = formatDate(new Date(timestampMilliseconds), 'EEE', locale);
        } else {
          dateToString = date;
        }
      }

      return dateToString;
    }

    return;
  }
}
